'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defer() {
  var reject = void 0;
  var resolve = void 0;

  var promise = new _q2.default.Promise(function (fst, snd) {
    resolve = fst;
    reject = snd;
  });

  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
}

exports.default = defer;
module.exports = exports['default'];